import React from 'react'
import { Box, ButtonBase, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, useParams } from 'react-router-dom';

function RouteButton({onClick, text}) {

    const buttonBaseStyles = {
        width: '100%',
        textAlign: 'left',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginTop: '10px',
    }

    const outerBoxStyles = {
        height: '40px',
        width: '100%',
        backgroundColor: '#D9D9D9',
        display:'flex',
        alignContent: 'center',
        borderRadius: '10px',
    }

    const textStyles = {
        marginTop: 'auto',
        marginBottom: 'auto',
        flexGrow: '1',
        marginLeft: '10px'
    }

    const chevronStyles = {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginRight: '10px'
    }
    
    return (
        <ButtonBase onClick={onClick} sx={buttonBaseStyles}>
            <Box sx={outerBoxStyles}>
                <Typography variant='body2' sx={textStyles}>{text}</Typography>
                <ChevronRightIcon sx={chevronStyles} />
            </Box>
        </ButtonBase>
    )
}

export default RouteButton